import { types } from "../action-types";

const initialState = {
    skills: [],
    loading: false,
    error: false,
  };
  
  const candidateSkillReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_CANDIDATE_SKILLS_INIT:
            return {
              ...state,
              loading: true,
            };
      
          case types.FETCH_CANDIDATE_SKILLS_SUCCESS:
            return {
              ...state,
              skills: action.payload,
              loading: false,
              error: false,
            };
            case types.FETCH_CANDIDATE_SKILLS_FAILURE:
              return {
                ...state,
                skills: [],
                loading: false,
                error: true,
              };
  
      default:
        return state;
    }
  };

  export default candidateSkillReducer;